module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-fade-in/wow-fade-in.component.scss
// module id = ./src/app/features/wow-slider/wow-fade-in/wow-fade-in.component.scss
// module chunks = main